module.exports = __webpack_public_path__ + "static/media/umbrella.29dfe410.svg";